import { FeatureFlagKey } from "../models/featureFlag";
import { useGetBoMeQuery } from "../store/services/api";
import { useGetFeatureFlagsByTenantQuery } from "../store/services/feature-flags";
import { useTenantScope } from "./useTenantScope";

export interface FeatureFlagState {
  enabled: boolean;
  loading: boolean;
}

export function useIsFeatureFlagEnabled(
  flagKey: FeatureFlagKey,
  tenantIdOverride?: string | null
): FeatureFlagState {
  const { data: me, isLoading: isLoadingMe } = useGetBoMeQuery();
  const scope = useTenantScope();

  const tenantId = tenantIdOverride ?? scope.tenantId ?? me?.defaultTenantId ?? null;

  const { data: flags, isLoading } = useGetFeatureFlagsByTenantQuery(tenantId ?? "", {
    skip: !tenantId,
  });

  const identityLoading = isLoadingMe || scope.loading;

  return {
    enabled: (flags ?? []).some((flag) => flag.flagKey === flagKey && flag.enabled),
    loading: identityLoading || (!!tenantId && isLoading),
  };
}
